import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
  Box,
} from '@material-ui/core';
import { Error as ErrorIcon } from '@material-ui/icons';
import { FileValidationResult } from '../util/fileContentInspector';

interface FileValidationErrorDialogProps {
  open: boolean;
  onClose: () => void;
  validationResult: FileValidationResult;
  fileName: string;
}

const FileValidationErrorDialog: React.FC<FileValidationErrorDialogProps> = ({
  open,
  onClose,
  validationResult,
  fileName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="file-validation-error-title"
      aria-describedby="file-validation-error-description"
    >
      <DialogTitle id="file-validation-error-title">
        <Box display="flex" alignItems="center" style={{ gap: 12 }}>
          <ErrorIcon style={{ color: '#f44336' }} />
          <Typography variant="h6" component="span">
            Upload Blocked
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="file-validation-error-description" style={{ marginBottom: 16 }}>
          <strong>{fileName}</strong> cannot be uploaded for security reasons.
        </DialogContentText>

        <DialogContentText style={{ marginBottom: 16, color: '#d32f2f' }}>{validationResult.reason}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileValidationErrorDialog;
